import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import fileDownload from 'js-file-download';

import { Checkbox } from '@material-ui/core';

import { utilHelper } from '../../helpers';
import OpbStatus from './OpbStatus';
import OpbItem from './OpbItem';
import PropertiesDialog from './PropertiesDialog';
import Confirm from '../Dialog/Confirm';
import { history } from '../../helpers';
import { commonService, siteService, opbcdtService } from '../../services';
import { alertActions } from '../../modules/alert';
import { IMEIInput, OpbNoSelect, OpbTypeSelect } from '../Common/InputBox';

class OpbState extends Component {
    mounted = true;
    xlsLoading = false;
    
    constructor(props) {
        super(props);
        if (!props.location.state) history.push("/login");

        this.state = {
            siteID: props.location.state.siteID,
            siteInfo: "",
            siteSummary: {
                totalCnt: 0,
                serviceCnt: 0,
                expireCnt: 0,
                stopCnt: 0
            },
            opbSearch: this.resetOpbSearch(props.location.state.siteID),

            checkedOpbList: [],
            checkedAllOpb: false,

            selectedOpbID: '',
            selectedOpbInfo: '',
            boardCodes: [],
            typeCodes: [],
            searchResult: null,
            open: false,
            callbackFunc: null,
            mode: '',
            nowDate: null,
        };

        this.setCommonCodes();
        this.handleOpbSearch();
    }

    componentDidMount = () => {
        utilHelper.getNowDate()
            .then(response => {
                this.setState({ nowDate: response === 200 ? new Date(response.data) : new Date() });
            })
            .catch(this.setState({ nowDate: new Date() }));
    };

    componentDidUpdate() {
        const { mySite } = this.props;
        const { siteID } = this.props.location.state;

        if (mySite.mySiteID && this.state.siteID !== siteID) {
            localStorage.setItem("mySiteID", mySite.mySiteID);

            this.setState({
                siteID: siteID,
                opbSearch: this.resetOpbSearch(siteID),
                selectedOpbID: '',
                selectedOpbInfo: '',
                checkedOpbList: [],
                checkedAllOpb: false,
                typeCodes: [],
                open: false
            }, () => {
                this.setCommonCodes();
                this.handleOpbSearch();
            });
        }
        else if (siteID) {
            localStorage.setItem("mySiteID", siteID);
        }
    }
    componentWillUnmount() {
        this.mounted = false;
    }


    changedOpbInfo = () => {
        //이전에 호출된 selectedOpbInfo가 없을 경우, 수정 사항이 없을 경우 false 그렇지 않은 경우 true
        if (!this.state.selectedOpbInfo ||
            !(this.state.selectedOpbInfo.floorsStatus || this.state.selectedOpbStatus))
            return false;
        return true;
    };

    resetOpbSearch = (siteID) => {
        return {
            siteID: siteID,
            siteNum: '',
            opbNo: -1,
            imei: '',
            boardCode: '',
            typeCode: '',
            opbStatus: '',
            connectYN: '',
            listCount: 1000,
            currentPage: 1,
            startPage: 1,
            endPage: 1,
            totalPage: 1,
        };
    };

    stateRefresh = () => {
        // 초기화
        this.setState({
            opbSearch: this.resetOpbSearch(this.state.opbSearch.siteID),
            selectedOpbID: '',
            selectedOpbInfo: '',
            typeCodes: [],
            open: false
        }, () => { this.handleOpbSearch(); });
    };

    selectedOpbInfoRefresh = () => {
        // 선택한 Display를 해제한다.
        this.setState({
            selectedOpbID: '',
            selectedOpbInfo: '',
        });
    };

    setCommonCodes = async () => {
        //현장 정보 조회
        let formData = new FormData();
        formData.append('siteID', this.state.siteID);
        formData.append('findFlag', "F");
        siteService.getSiteInfo(formData)
            .then(response => {
                this.setState({ siteInfo: response.data });
            })
            .catch(this.handleErrors);

        //요약정보 조회
        opbcdtService.getOpbSummary(this.state.siteID)
            .then(response => {
                this.setState({ siteSummary: response.data });
            })
            .catch(this.handleErrors);

        //Display 보드코드 조회
        commonService.findOpbTypeCodes(null)
            .then(response => {
                this.setState({ boardCodes: response.data });
            })
            .catch(this.handleErrors);
    };

    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    };

    handleValueChange = (e) => {
        this.setState({
            opbSearch: {
                ...this.state.opbSearch,
                [e.target.name]: e.target.value
            }
        });

        if (e.target.name === 'boardCode' && e.target.value !== '')
            this.setStateTypeCodes(e.target.value);
    };

    getCurrentPage = (currentPage) => {
        // 선택한 페이지로 이동
        this.setState({
            opbSearch: {
                ...this.state.opbSearch,
                currentPage: currentPage
            }
        }, () => { this.handleOpbSearch(); });
    };

    setStateTypeCodes = (boardCode) => {
        //Display 타입코드 조회
        let formData = new FormData();
        formData.append('parentCode', boardCode);

        commonService.findOpbTypeCodes(formData)
            .then(response => {
                this.setState({ typeCodes: response.data });
            })
            .catch(this.handleErrors);
    };

    setSelectedOpbInfo = (opbID) => {
        //Display 호기 선택 TAB 조회 
        let formData = new FormData();
        formData.append("siteID", this.state.opbSearch.siteID);
        formData.append("opbID", opbID);
        opbcdtService.selectedOpb(formData)
            .then(response => {
                console.log("opbState.js > setSelectedOpbInfo");
                console.log(response.data);
                if (this.mounted) {
                    this.setState({
                        selectedOpbInfo: response.data,
                    });
                }
            })
            .catch(this.handleErrors);
    };

    confirmOpbSearch = () => {
        if (this.changedOpbInfo()) {
            this.setState({
                open: true,
                callbackFunc: this.handleOpbSearch
            });
        } else
            this.handleOpbSearch();
    };

    setStateOpbSearch = (opbSearch) => {
        this.setState({
            opbSearch: opbSearch,
        }, this.confirmOpbSearch);
    };

    runOpbSearchByStatus = (status) => {
        let opbSearch = this.resetOpbSearch(this.state.opbSearch.siteID);
        opbSearch.opbStatus = status;
        this.setStateOpbSearch(opbSearch);
    };

    runOpbSearchByConnect = (connectYN) => {
        let opbSearch = this.resetOpbSearch(this.state.opbSearch.siteID);
        opbSearch.connectYN = connectYN;
        this.setStateOpbSearch(opbSearch);
    };

    handleOpbSearchClick = (e) => {
        let opbSearch = {
            ...this.state.opbSearch,
            opbStatus: '',
        };
        this.setStateOpbSearch(opbSearch);
    };

    handleOpbSearch = () => {
        // Display 현황 리스트 정보
        let formData = new FormData();
        formData.append("siteID", this.state.opbSearch.siteID);
        formData.append("listCount", this.state.opbSearch.listCount);
        formData.append("currentPage", this.state.opbSearch.currentPage);
        if (this.state.opbSearch.opbNo !== -1 && this.state.opbSearch.opbNo !== "-1") formData.append("opbNo", this.state.opbSearch.opbNo);
        if (this.state.opbSearch.opbStatus !== "") formData.append("opbStatus", this.state.opbSearch.opbStatus);
        if (this.state.opbSearch.connectYN !== "") formData.append("connectYN", this.state.opbSearch.connectYN);
        if (this.state.opbSearch.boardCode !== "") formData.append("boardCode", this.state.opbSearch.boardCode);
        if (this.state.opbSearch.typeCode !== "") formData.append("typeCode", this.state.opbSearch.typeCode);
        if (this.state.opbSearch.imei !== "") formData.append("imei", this.state.opbSearch.imei);

        opbcdtService.findOpbList(formData)
            .then(response => {
                if(this.mounted) {
                    this.setState({
                        searchResult: response.data,
                        opbSearch: {
                            ...this.state.opbSearch,
                            currentPage: response.data.currentPage,
                            startPage: response.data.startPage,
                            endPage: response.data.endPage,
                            totalPage: response.data.totalPage,
                        },
                        //선택한 Display를 해제한다.
                        selectedOpbID: '',
                        selectedOpbInfo: '',
                    });
                    if (this.state.searchResult.totalCount === 0) {
                        this.props.errorAlerts("검색 결과가 없습니다.");
                        //선택한 Display를 해제한다.
                        this.setState({
                            selectedOpbID: '',
                            selectedOpbInfo: '',
                        });
                    }
                }
            })
            .catch(this.handleErrors);
    };

    handleCheckedAllOpb = (e) => {
        const { checked } = e.target;
        const { searchResult } = this.state;

        this.setState({
            checkedAllOpb: checked,
            checkedOpbList: checked ? searchResult.opbCdtList.filter(opbInfo => opbInfo.opbStatus === "ST001") : []
        });
    };

    handleCheckedOpb = (checkedOpb, ck) => {
        const { checkedOpbList, searchResult } = this.state;

        this.setState({
            checkedOpbList: ck ? checkedOpbList.concat(checkedOpb) : checkedOpbList.filter(opb => opb !== checkedOpb),
            checkedAllOpb: ck ? checkedOpbList.concat(checkedOpb).length === searchResult.opbCdtList.filter(opbInfo => opbInfo.opbStatus === "ST001").length : false
        });
    };

    handleScreenModButton = () => {
        const { checkedOpbList } = this.state;
        const opbInfo = {
            siteID: this.state.siteID,
            coBeginDate: this.state.siteInfo.contractBeginDate,
            coEndDate: this.state.siteInfo.contractEndDate,
        };

        if (checkedOpbList.length > 0) history.push("/screenMod", { checkedOpbList: checkedOpbList, opbInfo: opbInfo });
        else this.props.errorAlerts("선택된 Display가 없습니다.");
    };

    handleSelectedOpb = (opbID, mode) => {
        // opbID 선택 시 이전에 호출된 selectedOpbInfo가 있고 수정 사항이 있을 경우 호출
        this.setState({
            mode: mode
        });

        if (this.changedOpbInfo()) {
            this.setState({
                open: true,
                selectedOpbID: opbID,
                callbackFunc: this.handleGoOpb
            });
        }
        else
            this.setSelectedOpbInfo(opbID);
    };

    handleSelectedOpbStatus = () => {
        this.setState({
            selectedOpbStatus: true
        });
    };

    handleGoOpb = () => {
        // 새로운 selectedOpbInfo 호출
        this.setSelectedOpbInfo(this.state.selectedOpbID);
        this.setState({
            selectedOpbStatus: false
        });
    };

    handleFormSubmit = (e) => {
        this.state.callbackFunc();
    };

    handleConfirmClose = (e) => {
        // Confirm 컴포넌트 창닫기
        this.setState({
            open: false
        });
    };

    excelOpbContentsList = () => {
        if (this.xlsLoading === true) {
            alert("엑셀 다운로드 중입니다. 잠시만 기다려주세요.");
        } else {
            //Display 컨텐츠 목록 엑셀 다운로드
            this.xlsLoading = true;
            let formData = new FormData();
            formData.append("siteID", this.state.opbSearch.siteID);
            if (this.state.opbSearch.opbNo !== -1 && this.state.opbSearch.opbNo !== "-1") formData.append("opbNo", this.state.opbSearch.opbNo);
            if (this.state.opbSearch.opbStatus !== "") formData.append("opbStatus", this.state.opbSearch.opbStatus);
            if (this.state.opbSearch.connectYN !== "") formData.append("connectYN", this.state.opbSearch.connectYN);
            if (this.state.opbSearch.boardCode !== "") formData.append("boardCode", this.state.opbSearch.boardCode);
            if (this.state.opbSearch.typeCode !== "") formData.append("typeCode", this.state.opbSearch.typeCode);
            if (this.state.opbSearch.imei !== "") formData.append("imei", this.state.opbSearch.imei);
            
            opbcdtService.getOpbContentsListXls(formData)
                .then(response => {
                    if (this.mounted) {
                        this.xlsLoading = false;
                        fileDownload(response.data, "엘리베이터_Display컨텐츠목록현황자료_" + utilHelper.getStringDate(new Date(), true, "_") + "_" + utilHelper.getStringTime(new Date(), true, "_") + ".xlsx");
                    }
                })
                .catch(this.handleErrors);
            
        }
    };
   

    render() {
        const { siteSummary, siteInfo, opbSearch, boardCodes, typeCodes, searchResult, checkedAllOpb, checkedOpbList, nowDate, selectedOpbInfo, mode, open } = this.state;

        return (
            <React.Fragment>
                <h2 className="s-page-tit">
                    Display현황
                </h2>
                <Row>
                    <Col xs={12} md={12} className="col">
                        <Row>
                            <Col md={8}>
                                <div className="opbstate-status-wrapper s-normal-box">
                                    <Row>
                                        <Col className="col opbstate-sub-title text-align-left">계약상태</Col>
                                    </Row>
                                    <Row className="opbstate-status-list">
                                        <Col xs={6} md={3} className="col">
                                            <OpbStatus opbStatus="" count={siteSummary.totalCnt} handleOpbSearch={this.runOpbSearchByStatus} />
                                        </Col>
                                        <Col xs={6} md={3} className="col">
                                            <OpbStatus opbStatus="ST001" count={siteSummary.serviceCnt} handleOpbSearch={this.runOpbSearchByStatus} />
                                        </Col>
                                        <Col xs={6} md={3} className="col">
                                            <OpbStatus opbStatus="ST003" count={siteSummary.expireCnt} handleOpbSearch={this.runOpbSearchByStatus} />
                                        </Col>
                                        <Col xs={6} md={3} className="col">
                                            <OpbStatus opbStatus="ST002" count={siteSummary.stopCnt} handleOpbSearch={this.runOpbSearchByStatus} />
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="opbstate-status-wrapper s-normal-box">
                                    <Row>
                                        <Col className="col opbstate-sub-title text-align-left">연결상태</Col>
                                    </Row>
                                    <Row className="opbstate-status-list">
                                        <Col xs={6} md={6} className="col">
                                            <OpbStatus opbStatus="Y" count={siteSummary.connectY} handleOpbSearch={this.runOpbSearchByConnect} />
                                        </Col>
                                        <Col xs={6} md={6} className="col">
                                            <OpbStatus opbStatus="N" count={siteSummary.connectN} handleOpbSearch={this.runOpbSearchByConnect} />
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <div className="h20"></div>
                        <Row>
                            <Col md={12}>
                                <div className="search-wrapper s-normal-box">
                                    <Row>
                                        <Col xs={6} md={1} className="col search-title">호기번호</Col>
                                        <Col xs={6} md={2} className="col">
                                            <OpbNoSelect opbList={siteInfo.siteOpbList} opbNo={opbSearch.opbNo} handleValueChange={this.handleValueChange} />
                                        </Col>
                                        <Col xs={6} md={1} className="col search-title">IMEI</Col>
                                        <Col xs={6} md={2} className="col">
                                            <IMEIInput imei={opbSearch.imei} handleValueChange={this.handleValueChange} />
                                        </Col>
                                        <Col xs={6} md={1} className="col search-title">타입</Col>
                                        <Col xs={6} md={3} className="col">
                                            <OpbTypeSelect boardCodes={boardCodes} typeCodes={typeCodes} boardCode={opbSearch.boardCode} typeCode={opbSearch.typeCode} handleValueChange={this.handleValueChange} />
                                        </Col>
                                        <Col xs={6} md={1} className="col">
                                            <div><button className="button outline-button table-button table-top-button" name="초기화" onClick={this.stateRefresh}><img src="/assets/images/ic-refresh.svg" className="ic-refresh" alt="초기화" />초기화</button></div>
                                        </Col>
                                        <Col xs={6} md={1} className="col">
                                            <div><button className="button primary-button table-button table-top-button" variant="contained" color="primary" onClick={this.handleOpbSearchClick}>검색</button></div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <div className="h20"></div>
                        <div className="opbstate-middle-wrapper" >
                            <div>전체 <Checkbox name="checkedAllOpb" color="primary" checked={checkedAllOpb} onChange={this.handleCheckedAllOpb} /></div>
                            <div><button className="button outline-button table-button table-top-button" style={{ width: '122px' }} name="엑셀 다운로드" onClick={this.excelOpbContentsList}><img src="/assets/images/download_gray.svg" className="ic-refresh" alt="엑셀 다운로드" />엑셀 다운로드</button></div>
                        </div>
                        <Row className="opbstate-opbitem-list">
                            {searchResult && searchResult.opbCdtList.map((opbInfo, i) => {
                                return <OpbItem key={i}
                                    opbInfo={opbInfo}
                                    active={checkedOpbList.filter(opb => opb === opbInfo).length > 0}
                                    nowDate={nowDate}
                                    handleCheckedOpb={this.handleCheckedOpb}
                                    handleSelectedOpb={this.handleSelectedOpb}
                                />;
                            })}
                        </Row>
                        <OverlayTrigger show={true} overlay={
                            <Tooltip>
                                <div>Display 선택 후 아래 화면편집을 누르세요.</div>
                            </Tooltip>
                            }>
                            <div className="opbState-screenMod-button" style={{ cursor: "pointer" }} onClick={this.handleScreenModButton}>
                                <div style={{ marginRight: "10px" }}>화면편집</div>
                                <div>{checkedOpbList.length}</div>
                            </div>
                        </OverlayTrigger>
                    </Col>

                    <Col xs={12} md={12} className="col opbstate-modify-pane">
                        {selectedOpbInfo &&
                            <PropertiesDialog opbInfo={selectedOpbInfo} mode={mode} handleSelectedOpbStatus={this.handleSelectedOpbStatus} selectedOpbInfoRefresh={this.selectedOpbInfoRefresh} />
                        }
                    </Col>
                </Row>
                {open === true &&
                    <Confirm message={"취소하시겠습니까? 입력한 정보는 초기화됩니다."} kind={"fail"} handleFormSubmit={this.handleFormSubmit} handleClose={this.handleConfirmClose} />
                }
            </React.Fragment>
        );
    }
}

function mapState(state) {
    const { mySite } = state;
    return { mySite };
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(OpbState);